export default __webpack_public_path__ + "static/media/TJK.bcbdc762.svg";